// libs
import React from "react";
import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";

// utils
import formatDatesSet from "../../Utils/Date/Dateset";

const LevelGraph = (props) => {
	const { data } = props;

	const { t, i18n } = useTranslation();

	const hoursToEmpty = data[data.length - 1].hoursToEmpty;
	const daysToEmpty = Math.round(hoursToEmpty/24);
	const isSingularDays = (!data[0].endDate);
	const lastPercentage =  Math.round((parseFloat(data[data.length - 1].lastLevel) * 100));

	const mapSeries = () => {
		let lowLevelData = data.map(() => data[0].lowLevel);
		let criticalLevelData = data.map(() => data[0].criticalLevel);
		let levelData = data.map((datum) => (datum.lastLevel) ? Math.round((parseFloat(datum.lastLevel) * 100)) : 0);
		let daysToEmptyData = data.map((datum,index) => {
			let percentage = null;
			if(index === data.length -1) percentage = lastPercentage;
			return percentage;
		});

		if(isSingularDays){
			for(let i = 1; i < daysToEmpty && i <= 4; i ++){
				lowLevelData.push(data[0].lowLevel);
				criticalLevelData.push(data[0].criticalLevel);
				levelData.push(null);
				daysToEmptyData.push( parseInt(lastPercentage) - (i / daysToEmpty * lastPercentage));
			}
		}

		let series = [
			{
				name: t("tanks.details.data.level.graph.level"),
				type: "area",
				data: levelData
			},
			{
				name: t("tanks.details.data.level.graph.level_low"),
				type: "area",
				data: lowLevelData
			},
			{
				name: t("tanks.details.data.level.graph.level_critical"),
				type: "area",
				data: criticalLevelData
			}
		];

		if(isSingularDays){
			series.push({
				name: t("tanks.details.data.level.graph.time_to_empty"),
				type: "area",
				data: daysToEmptyData
			});
		}

		return series;
	}

	const mapDates = () => {
		let datesArray = data.map( (datum) => formatDatesSet(datum.startDate,datum.endDate,i18n));
		if(isSingularDays){
			for(let i = 1; i < daysToEmpty; i ++){
				const lastDay = new Date(data[data.length - 1].startDate).getTime();
				const oneDayTime = 60 * 60 * 24 * 1000;
				const dateString = new Date(lastDay + (oneDayTime * i)).toISOString()

				datesArray.push(formatDatesSet(dateString,null,i18n));
			}
		}
		return datesArray;
	};

	const labelLegend = [
		t("tanks.details.data.level.graph.level"),
		t("tanks.details.data.level.graph.level_low"),
		t("tanks.details.data.level.graph.level_critical")
	];
	const colors = ["#55B545","#F2994A", "#EE1B21"]
	const opacity = [0.6, 0.35, 0.35];
	const strokeWidth = [4, 0, 0]

	if(isSingularDays){
		labelLegend.push(t("tanks.details.data.level.graph.time_to_empty"));
		colors.push("#ECECEC");
		opacity.push(0.8)
		strokeWidth.push(4);
	}

	return (
		<>
			<ReactApexChart
				options={{
					chart: {
						height: 300,
						width: "100%",
						type: "area",
						stacked: false,
						zoom: { enabled: false },
						toolbar: { show: false },
					},
					plotOptions: {
						bar:{
							columnWidth: "70%",
						},
						area:{
							fillTo: "end"
						}
					},
					dataLabels: {
						enabled: false,
					},
					stroke: {
						width: strokeWidth,
						curve: "straight"
					},
					colors: colors,
					fill: {
						opacity: opacity,
						type: 'gradient',
						gradient: {
							inverseColors: false,
							shade: 'light',
							shadeIntensity: 1,
							type: "vertical",
							opacityFrom: 0.65,
							opacityTo: 0.1,
							stops: [20, 100, 100, 100]
						},
					},
					xaxis: {
						type: "category",
						tooltip: { enabled: false },
						categories: mapDates()
					},
					yaxis: {
						min: 0,
						max: 100,
						axisTicks: {
							show: true,
							offsetX: 0,
						},
						axisBorder: {
							show: true,
							color: "#DCDCDC",
							offsetX: 0,
						},
						labels: {
							style: { colors: "#333333" },
							formatter: function (val) {
								return Math.round(val) + " %";
							}
						},
						title: {
							text: t("tanks.details.data.level.graph.yaxis_title"),
							style: { color: "#333333" },
						},
						tooltip: { enabled: false },
					},
					tooltip: {
						enabledOnSeries: [0],
						fixed: {
							enabled: false,
							position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
							offsetY: 0,
							offsetX: 0,
						},
					},
					legend: {
						horizontalAlign: "left",
						customLegendItems: labelLegend,
						offsetX: 40,
					},
				}}
				series={ mapSeries() }
				type="line"
				height={350}
			/>
		</>
	);
};

export default LevelGraph;
